import debounce from 'lodash/debounce';

export class GridMarker {
    private rows;
    // private element;
    // private grid;
    private index;
    private gridApi;
    private unwatch;

    constructor(gridApi: any) {
        this.gridApi = gridApi;
        // this.grid = grid;
        // this.element = grid.element;
        this.rows = [];
        this.index = 0;
    }

    updateGridApi(gridApi: any) {
        this.gridApi = gridApi;
    }

    reset() {
        this.index = 0;
    }

    next() {
        this.index++;
        this.render();
    }

    prev() {
        if (this.index > 0) {
            this.index--;
        }
        this.render();
    }

    getMarkedRow() {
        return this.rows[this.index];
    }

    activate() {
        const debouncedRender = debounce(() => {
            this.rows = this.grid.rows.filter(predicate => {
                return predicate.entity.id;
            });
            this.render();
        }, 100);

        this.unwatch = this.grid.registerDataChangeCallback(() => {
            debouncedRender();
        });
        debouncedRender();
    }

    deactivate() {
        this.index = 0;
        this.clearCurrentView();
        this.unwatch && this.unwatch();
    }

    private clearCurrentView() {
        this.element.find('.a9-grid-cell-marked').removeClass('a9-grid-cell-marked');
    }

    private render() {
        this.clearCurrentView();
        if (this.rows.length) {
            if (this.index > this.rows.length - 1) {
                this.index = this.rows.length - 1;
            } else if (this.index < 0) {
                this.index = 0;
            }
            const row = this.element.find(`.ui-grid-row:nth-child(${this.index + 1})`);
            if (row.length) {
                row.find('.ui-grid-cell').addClass('a9-grid-cell-marked');
            }
        }
    }

    private get grid() {
        return this.gridApi.grid;
    }

    private get element() {
        return this.gridApi.grid.element;
    }
}
